import PowerBalanceDocument from './components/PowerBalanceDocument';
import { buildPowerBalanceFileName } from './powerBalanceDocumentModel';
import { buildDocumentPrintHtml, printDocument } from '../../shared/documents/documentPrint';

const businessCss = `.pb-document__notice{padding:3mm;border:.3mm solid var(--document-border)}.pb-document__notice.is-warning{border-color:var(--document-accent);border-style:dashed}.pb-document__calculated,.pb-document__summary dt{color:var(--document-muted)}.pb-document__branch{position:relative;margin-top:6mm}.pb-document__branch>header{display:flex;align-items:flex-end;justify-content:space-between;gap:8mm;break-after:avoid}.pb-document__branch h3{margin:0 0 1mm;color:var(--document-secondary);font-size:11pt}.pb-document__summary{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:3mm 6mm;margin:0}.pb-document__summary div{display:grid;min-width:22mm}.pb-document__summary dd{margin:0;font-weight:700}.pb-document__branch .erp-document-table{margin-top:3mm}.pb-document__group th{text-transform:uppercase}.pb-document__branch tr.is-disabled{color:#707780;text-decoration:line-through}.pb-document__appendix>div{display:grid;gap:1mm;margin:0 0 3mm;break-inside:avoid}.pb-document__appendix p{margin:1mm 0}.pb-document__issues{padding-left:4mm;border-left:.8mm solid var(--document-border)}`;

export const buildPowerBalancePrintHtml = async (model, options) => buildDocumentPrintHtml({
  element: <PowerBalanceDocument model={model} options={options} />,
  title: buildPowerBalanceFileName(model).replace(/\.pdf$/, ''),
  orientation: 'landscape',
  styles: businessCss,
});

export const printPowerBalanceDocument = async (model, options) => {
  const fileName = buildPowerBalanceFileName(model);
  await printDocument({
    element: <PowerBalanceDocument model={model} options={options} />,
    title: fileName.replace(/\.pdf$/, ''),
    orientation: 'landscape',
    styles: businessCss,
  });
  return fileName;
};
